import type { SessionSummary } from '@/src/dal/session-dal'

import { selectVoiceAssessmentSessions } from './select-voice-assessment-sessions'

/** Poll interval while latest voice assessment is awaiting backend analysis. */
export const VOICE_ASSESSMENT_PENDING_ANALYSIS_POLL_MS = 20_000

export function getLatestVoiceAssessmentSessionSummary(
  sessions: readonly SessionSummary[] | undefined,
  sessionDefinitionIds: readonly number[],
): SessionSummary | null {
  const [latest] = selectVoiceAssessmentSessions(sessions, sessionDefinitionIds)
  return latest ?? null
}

/**
 * True when the newest voice-assessment session is still in `PendingAnalysis`.
 * Used to gate background refetches so we only poll while analysis may complete.
 */
export function isLatestVoiceAssessmentPendingAnalysis(
  sessions: readonly SessionSummary[] | undefined,
  sessionDefinitionIds: readonly number[],
): boolean {
  const latest = getLatestVoiceAssessmentSessionSummary(
    sessions,
    sessionDefinitionIds,
  )
  if (latest == null) {
    return false
  }
  return latest.status === 'PendingAnalysis'
}
